import { inject, injectable } from "inversify";
import { ApiData } from "../../data/apiData";
import { PasswordRequirements } from "../../data/passwordRequirements";
import { ProductData } from "../../data/productData";
import { ShowcasePageData } from "../../data/showcasePageData";
import IConfigService from "./IConfigService";
import { ConfigApi } from "../api/ConfigApi";
import { DiTokens } from "../diTokens";
import IAlertService from "../alert/IAlertService";
import IErrorService from "../error/IErrorService";
import { Curs, Curses } from "../../data/currencyRates";

@injectable()
/**Сервис настроек веб клиента */
export default class ConfigService implements IConfigService {
  constructor(
    @inject(DiTokens.AlertService) private alertService: IAlertService,
    @inject(DiTokens.ErrorService) private errorService: IErrorService
  ) {}
  /**
   * Получение данных API
   * @returns Объект ApiData
   */
  public async fetchApiState(): Promise<ApiData> {
    let resp: ApiData = new ApiData();
    try {
      resp = await ConfigApi.syncApiState();
    } catch (e) {
      await this.errorService.errorHandler(e, true, false, "");
    }
    return resp;
  }

  /**
   * Получение требований к паролю.
   * @returns Требования к паролю
   */
  public async fetchPasswordRequirements(): Promise<PasswordRequirements> {
    let resp: PasswordRequirements = new PasswordRequirements();
    try {
      resp = await ConfigApi.getPasswordRequirementsAsync();
    } catch (e) {
      await this.errorService.errorHandler(e, false, false, "");
    }
    return resp;
  }

  public async getProductsAsync(
    productsFile: any
  ): Promise<Array<ProductData>> {
    try {
      return await ConfigApi.getProductsAsync(productsFile);
    } catch (e) {
      await this.errorService.errorHandler(e, false, false, "");
    }
    return [];
  }

  public async fetchShowcase(requestLink: string): Promise<Array<ShowcasePageData>> {
    let resp: Array<ShowcasePageData> = [];
    try {
      resp = await ConfigApi.getShowcase(requestLink);
    } catch(e: any) {
      this.alertService.error(e.message);
    }
    return resp;
  }

  public async getQuiqOperationsAsync(
    productsFile: any
  ): Promise<Array<ProductData>> {
    try {
      return await ConfigApi.getQuiqOperationsAsync(productsFile);
    } catch (e) {
      await this.errorService.errorHandler(e, false, false, "");
    }
    return [];
  }

  
  public async getCurrencyRatesAsync(cursCode: string): Promise<Curses> {
    try {
      const curses: Curses = await ConfigApi.getCurrencyRatesAsync(cursCode);
      if (curses)
        return curses;
    } catch (e) {
      await this.errorService.errorHandler(e, false, false, "");
    }
  }
}
